import React from 'react'
import { useTableContext } from '../Context'
import map from 'lodash/map'
import { useTableBody } from '../hooks/useTableBody'

export const TableBody = () => {
  const { listResult } = useTableContext()

  return (
    <tbody>
      {map(listResult?.list, (listItem, index) => {
        return <Row key={`${listItem?._id}_${index}`} index={index} listItem={listItem} />
      })}
    </tbody>
  )
}

const Row = ({ listItem, index }: { listItem: any; index: number }) => {
  const { BodyRow, onRowDoubleClick, key, highlightClassName, onRowClick, renderDataBodyCell } = useTableBody(
    listItem,
    index
  )

  return (
    <tr className={highlightClassName} onClick={onRowClick} onDoubleClick={onRowDoubleClick}>
      {BodyRow ? (
        <BodyRow
          key={key}
          {...listItem}
          _highlightClassName={highlightClassName}
          _index={index}
          _renderDataBodyCell={renderDataBodyCell}
        />
      ) : (
        renderDataBodyCell()
      )}
    </tr>
  )
}
